<template>
  <b-modal
    :visible="shown"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hide="handleClose"
    hide-footer>

    <div slot="modal-title">
      <h4 class="m-0">Create a new project or select an existing project</h4>
      <div class="title-description">
        Tell us how you want to use this file
      </div>
    </div>

    <b-tabs content-class="my-0 mx-0 pb-0 no-border" v-model="tab" justified card>
      <b-tab title="Create a new project" no-body>
        <b-card class="mb-0">
          <b-row class="my-1">
            <b-col md="3">
              <label for="project-name">Project Name:</label>
            </b-col>
            <b-col md="9">
              <b-form-input
                  id="project-name"
                  size="md"
                  v-model="name"
                  type="text"
                  placeholder="Name"
                  :state="!name ? false : null"
                  required />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col md="3">
              <label for="project-description">Project Description:</label>
            </b-col>
            <b-col md="9">
              <b-form-textarea
                  id="project-description"
                  size="md"
                  rows="3"
                  v-model="description"
                  placeholder="Description" />
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="px-5"
            @click="saveChanges"
            :disabled="isSaving">
            <i class="fa fa-spin fa-spinner mr-2" v-if="isSaving"/>
            <span>Save&nbsp;</span>
          </b-button>
        </b-card>
      </b-tab>
      <b-tab title="Select an existing project" lazy no-body>
        <b-card class="mb-0">
          <b-row class="my-1">
            <b-col md="3">
              <label for="project-description">Select a Project:</label>
            </b-col>
            <b-col md="9">
              <b-form-select
                v-model="project"
                :options="projects"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                style="max-width: 300px;"
                size="md"
                @change="selectProject()">
              </b-form-select>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>

  </b-modal>
</template>

<script>
  import axios from "axios";
  import { fullURL } from "../../utils";

  export default {
    name: 'FileProjectModal',
    components: {},
    props: {
      shown: Boolean
    },
    
    data() {
      return {
        tab: 1,
        isSaving: false,
        // projects: this.$store.state.files.projectList,
        project: this.$store.state.files.activeProject,
        name: null,
        description: null
      };
    },

    methods: {
      handleClose() {
        console.log("Project: ", this.project)
        this.$emit('close');
      },

      getActiveProject(id) {
        var project = null;
        this.$store.state.projectList.forEach(p => {
          if (p['_id'] === id) {
            project = p;
          }
        });
        return project;
      },

      selectProject() {
        this.$store.state.activeProject = this.project;
        this.$emit('success');
        this.handleClose();
      },

      saveChanges() {
        this.isSaving = true;
        var data = {"name": this.name};
        if (!!this.description) {
          data["description"] = description;
        }
        axios.post(fullURL(`/project`), data).then(({data}) => {
            console.log("Project: ", data);
            this.isSaving = false;
            this.$store.state.files.projectList.push(data);
            this.project = data;
            this.$emit('success');
            this.handleClose();
            axios.post(fullURL(`/project/active`), {projectID: data['_id']}).then(({data}) => {
                console.log("Active Project: ", data);
                if (!this.$store.state.files.projectList) {
                  axios.post(fullURL(`/project/all`), {}).then(({data}) => {
                    this.$store.state.files.projectList = data;
                  });
                }
                this.$store.state.files.projectList.forEach(project => {
                  if (project['_id'] === data['project']) {
                    this.$store.state.files.activeProject = project;
                  }
                });
              }
            );
          }
        );
      }
    },

    computed: {
      projects() {
        return this.$store.state.files.projectList;
      },

      metaList() {
        return this.$store.state.general.metas;
      },
    }
  };
</script>

<style scoped>
  .title-description {
    font-weight: normal;
    font-size: .8em;
  }
</style>
